import Aos from "aos";
import "aos/dist/aos.css";
import "../Css/Animations.css";
import React, { useEffect } from "react";
import { Divider, Segment, Label, Icon } from "semantic-ui-react";
import "../Css/PortfolioSubBody.css";
import { SELF_IMG } from "../utils/datas";
import ArticlesTab from "./ArticlesTab";
import CustomRating from "./CustomRating";
import { readTextFile } from "../utils/table2td";
import { currentLang,Localizator } from "../utils/lang";
import BioFileReader from "../utils/fileReader";

document.onload = () => { };

function PortfolioSubBody() {
  /*
  const panes = [
    {
      menuItem: "Unity",
      render: () => (
        <Tab.Pane>
          <ArticlesTab
            articleGenre="portfolio"
            articleType="unity"
            subArticleType="project"
            menuItems={["project", "tool"]}
          >
          </ArticlesTab>
        </Tab.Pane>
      ),
    },
    { menuItem: "Web", render: () => <Tab.Pane>Web</Tab.Pane> },
    { menuItem: "Art", render: () => <Tab.Pane>Art</Tab.Pane> },
    { menuItem: "3D", render: () => <Tab.Pane>3D</Tab.Pane> },
  ];

  return (
    <div id="portfolio-subbody">
      <Tab menu={{ secondary: true, pointing: true }} panes={panes} />
    </div>
  );*/
  useEffect(() => {
    Aos.init();
    Aos.refresh();    
  }, []);

  return (
    <div id="portfolio-subbody">
      {/* 自我介紹 */}
      <div className="portfolio-self-container">
        {/*
        <div
          className="portfolio-self-nameTitle wipe-enter-animation"
          data-aos-easing="ease-out-cubic"
          data-aos-duration="2000"
        >
          Lontoone
        </div>
      */}
        {/* 左 - 資訊欄位 */}
        <div className="portfolio-self-infobox">
          {/* 圖片 */}
          <div
            className="fade-right portfolio-self-avator"
            data-aos="fade-right"
          >
            <img src={SELF_IMG} />
          </div>

          {/* 自我介紹 - 文字 */}
          <div className="portfolio-self-info-title" data-aos="fade-left">
            {Localizator("self_info_title")}
            <div className="portfolio-self-info">              
              {Localizator("self_info_text")}              
            </div>
            <Divider></Divider>
          </div>

          {/* 各項能力評分 */}
          <div className="" data-aos="fade-right">
            <div className="portfolio-self-info" data-aos="fade-right">
              <p className="portfolio-self-outlineBox">Using </p>
              <Label image>
                <img src="https://mpng.subpng.com/20180528/wjv/kisspng-unity-computer-icons-software-development-kit-5b0c54d08fdc65.1206305415275348005893.jpg" />
                Unity
              </Label>
              <Label image>
                <img src="https://i.imgur.com/rmmIG8Z.png" />
                Shader
              </Label>
              <Label image>
                <Icon name="react" color="blue" size="large" />
                React
              </Label>
              <Label image>
                <Icon name="python" color="blue" size="large" />
                Python
              </Label>
              <Label image>
                <img src="https://3.bp.blogspot.com/-yvrV6MUueGg/ToICp0YIDPI/AAAAAAAAADg/SYKg4dWpyC43AAfrDwBTR0VYmYT0QshEgCPcBGAYYCw/s1600/OpenCV_Logo.png" />
                OpenCV
              </Label>
              <Label image>
                <img src="https://cdn4.iconfinder.com/data/icons/google-i-o-2016/512/google_firebase-2-512.png" />
                Firebase
              </Label>
              <Label image>
                <img src="https://iconape.com/wp-content/png_logo_vector/c.png" />
                C#
              </Label>
              <Label image>
                <img src="https://www.designbust.com/download/240/png/php_icon512.png" />
                PHP
              </Label>
              <Label image>
                <img src="https://cdn-icons-png.flaticon.com/512/3161/3161115.png" />
                SQL
              </Label>
              <Label image>
                <img src="https://cdn.iconscout.com/icon/free/png-256/node-js-1174925.png" />
                Js
              </Label>
              <Label image>
                <img src="https://cdn.iconscout.com/icon/free/png-256/jquery-8-1175153.png" />
                JQuery
              </Label>
              <Label image>
                <Icon name="html5" color="orange" size="large" />
                HTML
              </Label>
              <Label image>
                <img src="https://cdn-icons-png.flaticon.com/512/919/919826.png" />
                Css
              </Label>
              <Label image>
                <img src="https://i.pinimg.com/736x/a2/dc/32/a2dc3249364449a49f01a6275d277b8c.jpg" />
                C++
              </Label>
              <Label image>
                <img src="https://w7.pngwing.com/pngs/743/345/png-transparent-bash-git-computer-icons-installation-command-line-interface-github-text-logo-windows-thumbnail.png" />
                Git
              </Label>
              <Label image>
                <img src="https://www.docker.com/wp-content/uploads/2022/03/vertical-logo-monochromatic.png" />
                Docker
              </Label>

              <p className="portfolio-self-outlineBox">Learned Before </p>
              <Label image>
                <img src="https://cdn.imgbin.com/16/14/13/imgbin-unreal-tournament-unreal-engine-4-game-engine-others-GsrM03gWgUqSBBYnGNmJa7w9s.jpg" />
                UE4
              </Label>
              <Label image>
                <img src="https://cdn-icons-png.flaticon.com/512/873/873107.png" />
                Azure
              </Label>
              <Label image>
                <img src="https://picture.mactechnews.de/Facebook/opengl.534279.png" />
                OpenGL
              </Label>
              <Label image>
                <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRGQQ4GhfNS5upsLd0XiSVni_Nnym4ThGOGgA6X5XsTYYlPqooK6JeFuoROLD6lGCzXHzw&usqp=CAU" />
                SPARQL
              </Label>

              {/* 語言??? 
              <Divider></Divider>              
              <div className="portfolio-rating-container">
                <p>English</p>
                <CustomRating color="white" value={9} max={10}></CustomRating>
              </div>              
              <div className="portfolio-rating-container">
                <p>Japaness</p>
                <CustomRating color="white" value={6} max={10}></CustomRating>
              </div>
              <div className="portfolio-rating-container">
                <p>Chinese</p>
                <CustomRating color="white" value={10} max={10}></CustomRating>
              </div>*/}
            </div>
          </div>
        </div>

        {/* 右 - 經歷 */}
        {/* 經歷 */}
        <div className="portfolio-self-infobox">
          <BioFileReader path="../datas/bio.txt"></BioFileReader>
        </div>
      </div>
      {/* 經歷 
      <div data-aos="fade-right" className="portfolio-self-infobox">
        <BioFileReader path="../datas/bio.txt"></BioFileReader>
      </div>*/}
      {/* <Segment data-aos="fade-right">END</Segment>*/}
    </div>
  );
}

export default PortfolioSubBody;
